import { useState } from 'react';
import { requestGeo, setGeoEnabled, useGeoStatus } from '../lib/geo';
import { cardCls, sectionTitleCls } from './ui/classes';

/** Przełącznik „Rozpoznawaj sklep z lokalizacji” (Dom). Włączenie to gest — wtedy przeglądarka pyta o zgodę. */
export function GeoSection() {
  const geo = useGeoStatus();
  const [busy, setBusy] = useState(false);
  const [info, setInfo] = useState<string | null>(null);

  const toggle = async () => {
    setInfo(null);
    if (geo.active) {
      setGeoEnabled(false);
      return;
    }
    setBusy(true);
    try {
      const res = await requestGeo();
      setGeoEnabled(res.status === 'granted');
      if (res.status === 'denied') setInfo('Brak zgody na lokalizację, więc rozpoznawanie sklepu zostaje wyłączone.');
      else if (res.status === 'granted' && !res.position) setInfo('Włączone. Położenia nie udało się teraz ustalić — spróbuję w sklepie.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="flex flex-col gap-2">
      <h2 className={sectionTitleCls}>Lokalizacja</h2>
      <div className={`${cardCls} overflow-hidden`}>
        {!geo.supported ? (
          <p className="p-4 text-sm text-stone-600 dark:text-stone-400">Ta przeglądarka nie udostępnia lokalizacji.</p>
        ) : geo.permission === 'denied' ? (
          <div className="flex flex-col gap-1 p-4 text-sm text-stone-600 dark:text-stone-400">
            <p className="font-medium text-stone-900 dark:text-stone-100">Lokalizacja jest zablokowana.</p>
            <p>
              Odblokuj ją w przeglądarce: stuknij ikonę obok adresu strony → Uprawnienia → Lokalizacja → Zezwalaj. W zainstalowanej aplikacji:
              Ustawienia telefonu → Aplikacje → Odhaczka → Uprawnienia → Lokalizacja.
            </p>
          </div>
        ) : (
          <button
            type="button"
            role="switch"
            aria-checked={geo.active}
            disabled={busy || geo.permission === undefined}
            onClick={() => void toggle()}
            className="flex min-h-14 w-full items-center gap-3 px-4 py-3 text-left active:bg-stone-50 disabled:opacity-60 dark:active:bg-stone-800"
          >
            <span className="min-w-0 flex-1">
              <span className="block font-medium">Rozpoznawaj sklep z lokalizacji</span>
              <span className="block text-sm text-stone-500">
                Podpowiem sklep przy nowej liście i w trybie sklepu. W trakcie zakupów zapiszę jedno położenie na wizytę, żeby nauczyć się, gdzie
                jest sklep.
              </span>
            </span>
            <span
              aria-hidden
              className={`relative h-7 w-12 shrink-0 rounded-full transition-colors ${geo.active ? 'bg-brand-600' : 'bg-stone-300 dark:bg-stone-700'}`}
            >
              <span
                className={`absolute top-0.5 left-0.5 size-6 rounded-full bg-white shadow transition-transform ${geo.active ? 'translate-x-5' : ''}`}
              />
            </span>
          </button>
        )}
        {info && <p className="px-4 pb-3 text-sm text-stone-600 dark:text-stone-400">{info}</p>}
      </div>
    </section>
  );
}
